import styled from "styled-components"

const Liner = styled.div`
  width: 80px;
  height: 4px;
  display: inline-block;
  background-color: goldenrod;
`

export default Liner